var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.729 5C5.729 3.89543 6.62443 3 7.729 3H17.2707C18.3752 3 19.2707 3.89543 19.2707 5V20.5278C19.2707 21.4268 18.1769 21.8692 17.5519 21.2231L13.2186 16.7431C12.8256 16.3368 12.1741 16.3368 11.7811 16.7431L7.44778 21.2231C6.82279 21.8692 5.729 21.4268 5.729 20.5278V5Z",
    fill: "#82B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.b7573c1c44f6d5c5d7a5c323005a9f0b.svg";
export { ForwardRef as ReactComponent };